import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d0ae608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "padding" }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = { class: "padding" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "cell-lt" }
const _hoisted_7 = { class: "cell-rt" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "HKD", -1))
const _hoisted_9 = { class: "cell" }
const _hoisted_10 = { class: "cell-lt" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*1", -1))
const _hoisted_12 = { class: "cell-rt" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "%", -1))
const _hoisted_14 = { class: "or" }
const _hoisted_15 = { class: "cell" }
const _hoisted_16 = { class: "cell-lt" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*1", -1))
const _hoisted_18 = { class: "cell-rt" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "HKD", -1))
const _hoisted_20 = { class: "padding" }
const _hoisted_21 = { class: "tip" }
const _hoisted_22 = { class: "tip-text" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "row-lt" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*2", -1))
const _hoisted_26 = { class: "row-rt" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "row-lt" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*2", -1))
const _hoisted_30 = { class: "row-rt" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "row-lt" }
const _hoisted_33 = {
  key: 0,
  class: "row-rt"
}
const _hoisted_34 = {
  key: 1,
  class: "row-rt row-rt-disable"
}
const _hoisted_35 = {
  key: 2,
  class: "row-rt row-rt-act"
}
const _hoisted_36 = { class: "row-rt-discount" }
const _hoisted_37 = { class: "row row-sub row-sub-first" }
const _hoisted_38 = { class: "row-lt row-lt-sub" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*2", -1))
const _hoisted_40 = { class: "row-rt row-rt-sub" }
const _hoisted_41 = { class: "row row-sub" }
const _hoisted_42 = { class: "row-lt row-lt-sub" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*3", -1))
const _hoisted_44 = { class: "row-rt row-rt-sub" }
const _hoisted_45 = { class: "row row-sub" }
const _hoisted_46 = { class: "row-lt row-lt-sub" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*3", -1))
const _hoisted_48 = { class: "row-rt row-rt-sub" }
const _hoisted_49 = { class: "row row-sub" }
const _hoisted_50 = { class: "row-lt row-lt-sub" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*4", -1))
const _hoisted_52 = { class: "row-rt row-rt-sub" }
const _hoisted_53 = { class: "row row-sub" }
const _hoisted_54 = { class: "row-lt row-lt-sub" }
const _hoisted_55 = { class: "row-rt row-rt-sub" }
const _hoisted_56 = { class: "row row-sub" }
const _hoisted_57 = { class: "row-lt row-lt-sub" }
const _hoisted_58 = {
  key: 1,
  class: "row-rt row-rt-sub"
}
const _hoisted_59 = { class: "desc" }
const _hoisted_60 = { class: "footer" }

import { TInput, TDivider, TCell } from '@tencent/web-vbui';
import { computed, reactive } from 'vue';
import { doCal } from '@common/lib/calculator';
import { formatBillListDate } from '@common/lib/dayjs';
import { baseMixins } from '@common/mixins/baseMixins';
import { i18n } from '@tencent/vb-web-base';
import { useAsyncState, whenever } from '@vueuse/core';
import { GetLoanConfigList } from '../../core/network/NodeAPI';
import { getUrlQuery } from '@common/utils/param';


export default /*#__PURE__*/_defineComponent({
  __name: 'leaseCal',
  setup(__props) {

const { formatThousandsToRaw, formatWithCommas } = baseMixins();

const { getT } = i18n;
const $t = getT();

const lang = getUrlQuery('lang') || i18n.getLang();

let timer: NodeJS.Timeout;

document.title = $t('先租后付计算器');

const state = reactive({
  originMonthRent: '20,000',
  originMonthRentTip: '',
  discount: '8.0',
  discountTip: '',
  discountMonthRent: '18,400',
  discountMonthRentTip: '',
  rewardRaw: 300,
  showPlan: false,
});

const tmp = {
  content: [] as { rewardAmt: string }[]
};

const { state: config, isReady } = useAsyncState(GetLoanConfigList<{ content: { rewardAmt: string }[] }>('loan_lease_V2'), tmp);

whenever(isReady, () => {
  // 先租后付配置
  const reward = +(config.value.content[0]?.rewardAmt || '0');
  if (reward) {
    state.rewardRaw = reward;
  }
});

const jump = () => {
  window.location.href = `https://www.fusionbank.com/h5/walletLoan/activity/index.html?lang=${lang}&activeTag=FusionAppFrontBanner&id=RNPL02#/leaseIntegrate`;
};

const result = computed(() => {
  const originMonthRentRaw = +formatThousandsToRaw(state.originMonthRent);
  const discountMonthRentRaw = +formatThousandsToRaw(state.discountMonthRent);
  if (originMonthRentRaw && originMonthRentRaw > 0 && originMonthRentRaw <= 70000 && +state.discount >= 0 && +state.discount < 100 && discountMonthRentRaw) {
    const discountYearRent = discountMonthRentRaw * 14;
    const originYearRent = originMonthRentRaw * 14;
    const { totalInterest, plan, apr } = cal();
    const totalExpendRaw = discountYearRent - state.rewardRaw + Number(totalInterest);
    return {
      plan,
      originYearRent: formatWithCommas(originYearRent),
      totalAmt: formatWithCommas(totalExpendRaw.toFixed(2)),
      totalSaveAmt: formatWithCommas((originYearRent - totalExpendRaw).toFixed(2)),
      actualYearRent: formatWithCommas(discountYearRent),
      discount: `${((originYearRent - totalExpendRaw) / originYearRent * 100).toFixed(1)}%`,
      apr: `${apr}%`,
      interest: formatWithCommas(totalInterest),
      reward: state.rewardRaw || '--',
      totalExpend: formatWithCommas(totalExpendRaw.toFixed(2)),
    };
  }
  return {
    plan: [],
    originYearRent: '--',
    totalAmt: '--',
    totalSaveAmt: '--',
    actualYearRent: '--',
    discount: '',
    apr: '--',
    interest: '--',
    reward: '--',
    totalExpend: '--',
  };
});

const cal = () => {
  const discountMonthRentRaw = +formatThousandsToRaw(state.discountMonthRent);
  const discountYearRent = discountMonthRentRaw * 14;
  let rate = 0;
  // 分段日利率
  if (discountYearRent > 0 && discountYearRent <= 150000) {
    rate = 0.0128;
  }
  if (discountYearRent > 150000 && discountYearRent <= 250000) {
    rate = 0.00640;
  }
  if (discountYearRent > 250000 && discountYearRent <= 800000) {
    rate = 0.00543;
  }
  if (discountYearRent > 800000 && discountYearRent <= 1000000) {
    rate = 0.00443;
  }
  return doCal(discountYearRent, rate, 12);
};

const formatPeriod = (src: number) => $t('第{num}期', { num: src });

// 计算防抖
const debounce = (callback: () => void) => {
  timer = setTimeout(() => {
    callback();
  }, 800);
};

const rentChange = (val: string, e: Event) => {
  console.log('rentChange', e.type);
  if (e.type !== 'input') return;
  clearTimeout(timer);
  const originMonthRentRaw = +formatThousandsToRaw(state.originMonthRent);
  state.originMonthRentTip = '';
  if (originMonthRentRaw < 0 || originMonthRentRaw > 70000) {
    state.originMonthRentTip = $t('月租金额必须在0-70,000之间');
  }
  state.discount = '';
  state.discountMonthRent = '';
  // if (state.originMonthRent && state.discount && !state.discountMonthRent) {
  //   debounce(() => {
  //     state.discount = (+state.discount).toFixed(1);
  //     state.discountMonthRent = formatWithCommas(originMonthRentRaw - (originMonthRentRaw * +state.discount / 100));
  //   });
  // }
  // if (state.originMonthRent && state.discountMonthRent) {
  //   const discountMonthRentRaw = +formatThousandsToRaw(state.discountMonthRent);
  //   if (originMonthRentRaw > discountMonthRentRaw) {
  //     debounce(() => {
  //       state.discount = ((originMonthRentRaw - discountMonthRentRaw) / originMonthRentRaw * 100).toFixed(1);
  //     });
  //   }
  // }
};

const discountChange = (val: string, e: Event) => {
  console.log('discountChange', e.type);
  if (e.type !== 'input') return;
  clearTimeout(timer);
  state.discountTip = '';
  if (+state.discount < 0 || +state.discount >= 100) {
    state.discountTip = $t('请输入0 - 100%以内的折扣');
  }
  if (state.originMonthRent && state.discount) {
    const originMonthRentRaw = +formatThousandsToRaw(state.originMonthRent);
    debounce(() => {
      state.discount = (+state.discount).toFixed(1);
      state.discountMonthRent = formatWithCommas(originMonthRentRaw - (originMonthRentRaw * +state.discount / 100));
    });
  }
};

const discountMonthRentChange = (val: string, e: Event) => {
  console.log('discountMonthRentChange', e.type);
  if (e.type !== 'input') return;
  clearTimeout(timer);
  if (state.originMonthRent && state.discountMonthRent) {
    const originMonthRentRaw = +formatThousandsToRaw(state.originMonthRent);
    const discountMonthRentRaw = +formatThousandsToRaw(state.discountMonthRent);
    if (originMonthRentRaw > discountMonthRentRaw) {
      debounce(() => {
        state.discount = ((originMonthRentRaw - discountMonthRentRaw) / originMonthRentRaw * 100).toFixed(1);
      });
    }
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref($t)('请输入您的租楼计划')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref($t)('原每月租金')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(TInput), {
              class: "cell-input",
              type: "tel",
              size: "large",
              modelValue: state.originMonthRent,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.originMonthRent) = $event)),
              tips: state.originMonthRentTip,
              theme: state.originMonthRentTip ? 'error' : 'default',
              "is-formatter": true,
              "has-border": false,
              "to-fixed": 0,
              maxlength: 6,
              "max-number": 70000,
              "min-number": 0,
              placeholder: _unref($t)('请输入'),
              onInput: rentChange
            }, null, 8, ["modelValue", "tips", "theme", "placeholder"]),
            _hoisted_8
          ])
        ]),
        _createVNode(_unref(TDivider), {
          size: "small",
          theme: "primary"
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_unref($t)('业主提供折扣')), 1),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(TInput), {
              class: "cell-input",
              type: "tel",
              size: "large",
              modelValue: state.discount,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.discount) = $event)),
              tips: state.discountTip,
              theme: state.discountTip ? 'error' : 'default',
              "is-formatter": false,
              "has-border": false,
              "to-fixed": 1,
              "max-number": 100,
              "min-number": 0,
              maxlength: 4,
              placeholder: _unref($t)('请输入'),
              onInput: discountChange
            }, null, 8, ["modelValue", "tips", "theme", "placeholder"]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref($t)('或')), 1)
        ]),
        _createVNode(_unref(TDivider), {
          size: "small",
          theme: "primary"
        }),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createTextVNode(_toDisplayString(_unref($t)('减租后每月租金')), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_unref(TInput), {
              class: "cell-input",
              type: "tel",
              size: "large",
              modelValue: state.discountMonthRent,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.discountMonthRent) = $event)),
              tips: state.discountMonthRentTip,
              theme: state.discountMonthRentTip ? 'error' : 'default',
              "is-formatter": true,
              "has-border": false,
              maxlength: 6,
              "to-fixed": 0,
              placeholder: _unref($t)('请输入'),
              onInput: discountMonthRentChange
            }, null, 8, ["modelValue", "tips", "theme", "placeholder"]),
            _hoisted_19
          ])
        ])
      ]),
      _createVNode(_unref(TDivider), { class: "nopadding" }),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref($t)('富融银行贷款助您租屋慳到尽!')), 1),
          _createElementVNode("div", {
            class: "tip-link",
            onClick: jump
          }, _toDisplayString(_unref($t)('查看活动')), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createTextVNode(_toDisplayString(_unref($t)('原１年租屋开支')), 1),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(result).originYearRent), 1)
        ]),
        _createVNode(_unref(TDivider), {
          size: "small",
          theme: "primary"
        }),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createTextVNode(_toDisplayString(_unref($t)('总开支（１年租屋开支')), 1),
            _hoisted_29,
            _createTextVNode(_toDisplayString(_unref($t)('+贷款利息-计划奖赏）')), 1)
          ]),
          _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(result).totalAmt), 1)
        ]),
        _createVNode(_unref(TDivider), {
          size: "small",
          theme: "primary"
        }),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, _toDisplayString(_unref($t)('预计总节省金额')), 1),
          (_unref(result).totalSaveAmt === '--')
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(result).totalSaveAmt), 1))
            : (+_unref(formatThousandsToRaw)(_unref(result).totalSaveAmt) < 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(result).totalSaveAmt), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("span", null, _toDisplayString(_unref(result).totalSaveAmt), 1),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(result).discount), 1)
                ]))
        ]),
        _createVNode(_unref(TDivider), {
          size: "small",
          theme: "primary"
        }),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createTextVNode(_toDisplayString(_unref($t)('减租后１年租屋开支')), 1),
            _hoisted_39
          ]),
          _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(result).actualYearRent), 1)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createTextVNode(_toDisplayString(_unref($t)('贷款实际年利率')), 1),
            _hoisted_43
          ]),
          _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(result).apr), 1)
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createTextVNode(_toDisplayString(_unref($t)('+ 贷款利息')), 1),
            _hoisted_47
          ]),
          _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(result).interest), 1)
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createTextVNode(_toDisplayString(_unref($t)('- 计划奖赏')), 1),
            _hoisted_51
          ]),
          _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(result).reward), 1)
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, _toDisplayString(_unref($t)('总开支')), 1),
          _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(result).totalExpend), 1)
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, _toDisplayString(_unref($t)('还款计划')), 1),
          (_unref(result).totalAmt !== '--')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "row-rt row-rt-sub link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (state.showPlan = !state.showPlan))
              }, _toDisplayString(_unref($t)('查看还款详情')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString('--')))
        ]),
        _createVNode(_unref(TDivider), {
          size: "small",
          theme: "primary"
        }),
        (state.showPlan)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(result).plan, (item, idx) => {
                return (_openBlock(), _createBlock(_unref(TCell), {
                  key: item.date,
                  class: "tcell",
                  "has-bottom-border": false,
                  "has-arrow": false,
                  "left-title": formatPeriod(idx + 1),
                  "left-label": _unref(formatBillListDate)(item.date),
                  "right-title": item.installment,
                  "right-label": `${_unref($t)('包括利息')} ${item.interest}`
                }, null, 8, ["left-title", "left-label", "right-title", "right-label"]))
              }), 128)),
              _createVNode(_unref(TDivider), {
                size: "small",
                theme: "primary"
              })
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("p", null, "*1 " + _toDisplayString(_unref($t)('预缴1年租金可提升的议价空间根据个别业主愿意提供折扣的程度而定。业主及租客之间的租赁安排及租赁协议与富融银行无关，富融银行亦不承担任何义务、责任或法律责任。')), 1),
          _createElementVNode("p", null, "*2 " + _toDisplayString(_unref($t)('1年租屋开支为12个月租金加2个月按金，即14个月租金。')), 1),
          _createElementVNode("p", null, "*3 " + _toDisplayString(_unref($t)('最终审批结果及利率因个别申请的实际情况而有所不同。以贷款额HKD257,600及12个月还款期(一年为365天或闰年366天)为计算基础，实际年利率(采用香港银行公会的有关指引计算，并按四舍五入计算至小数后两个位）为2.00% (已考虑利率折扣55折及首两月免息免供优惠) 或4.77% (不包括利率折扣及首两月免息免供优惠)。实际年利率是一个参考利率，以年化利率展示出包括银行产品的基本利率及其他费用与收费。 「个人信用额度」没有任何费用与收费。')), 1),
          _createElementVNode("p", null, "*4 " + _toDisplayString(_unref($t)('受条款及细则约束，详情请点击上方横幅中的 “查看活动”按钮。')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref($t)('计算结果仅供参考。富融银行对计算结果之任何信息、预测或陈述的准确性或完整性概不作出任何担保、声明或保证（明示或暗示），亦不会对此承担任何责任或法律责任。在任何情况下，富融银行概不就计算结果的任何建议、意见或陈述而引至的任何损失或破坏承担任何责任。')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref($t)('计算结果不反映实际贷款还款金额，实际贷款还款金额或会有差异，请参照富融银行确认之贷款资料为准。')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_60, _toDisplayString(_unref($t)('借定唔借？还得到先好借！')), 1)
    ])
  ]))
}
}

})